import { render, staticRenderFns } from "./pro-item.vue?vue&type=template&id=5afd37a2&scoped=true"
import script from "./pro-item.vue?vue&type=script&lang=js"
export * from "./pro-item.vue?vue&type=script&lang=js"
import style0 from "./pro-item.vue?vue&type=style&index=0&id=5afd37a2&prod&scoped=true&lang=scss"
import style1 from "./pro-item.vue?vue&type=style&index=1&id=5afd37a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd37a2",
  null
  
)

export default component.exports